const admin = {
  'admin-loading': 'Loading, please wait...',
  'geolocation-button': 'Geolocation',
  'newsletter-button': 'Newsletter',
  'custom-modal-admin-button': 'Homepage image'
};

export default admin;
